import { createGlobalStyle } from 'styled-components'

export const GlobalStyles = createGlobalStyle`
  * {
    box-sizing: border-box;
  }

  body {
    min-width: 320px;
    height: 100vh;
    overflow: hidden;
    background: ${({ theme }) => theme.colors.neutral.lightest};
    color: ${({ theme }) => theme.colors.grey.dark};
    font-family: ${({ theme }) => theme.fontFamily.milliard};
    -moz-osx-font-smoothing: grayscale;
    -webkit-font-smoothing: antialiased;
    text-size-adjust: none;
  }

  .font-roboto {
    font-family: ${({ theme }) => theme.fontFamily.roboto};
  }

  .font-milliard {
    font-family: ${({ theme }) => theme.fontFamily.milliard};
  }

  ul, h1, h2, h3, h4, h5, h6, p {
    margin: 0;
    padding: 0;
  }

  a, a:hover, a:focus, a:active {
    text-decoration: none;
    color: inherit;
  }

  h1, .h1 {
    ${({ theme }) => theme.typography.h4.normal};
  }

  h2, .h2 {
    margin-bottom: 0.875rem;
    ${({ theme }) => theme.typography.h5.normal};
  }

  h3, .h3 {
    ${({ theme }) => theme.typography.m.normal};
  }

  p, .p {
    ${({ theme }) => theme.typography.s.normal};
  }

  small, .small {
    ${({ theme }) => theme.typography.xs.normal};
  }

  ul {
    list-style-type: none;
  }

  button {
    border: none;
    outline: none;
    cursor: pointer;

    :hover {
      opacity: .9;
    }
  }

  // Helpers
  .inactive {
    pointer-events: none;
    opacity: .8;
  }

  .disabled {
    pointer-events: none;
  }

  .text-underline {
    text-decoration: underline;
  }

  // HTML default overwrites
  ::-webkit-scrollbar {
    width: 0.5rem;
    height: 0.5rem;
  }

  ::-webkit-scrollbar-track {
    background: ${({ theme }) => theme.colors.grey.lighter};
  }

  ::-webkit-scrollbar-thumb {
    border-radius: ${({ theme }) => theme.borderRadius.rounded};
    background: ${({ theme }) => theme.colors.grey.neutral};

    &:hover {
      background: ${({ theme }) => theme.colors.grey.neutral};

    }
  }

  .grey-scrollbar {
    ::-webkit-scrollbar-track {
      background-color: transparent;
    }

    ::-webkit-scrollbar-thumb {
      border-radius: ${({ theme }) => theme.borderRadius.rounded};
      background-color: ${({ theme }) => theme.colors.grey.neutral};

      &:hover {
        background-color: ${({ theme }) => theme.colors.grey.neutral};
      }
    }
  }

  ::placeholder {
    /* Chrome, Firefox, Opera, Safari 10.1+ */
    color: ${({ theme }) => theme.colors.grey.neutral};
    opacity: 1; /* Firefox */
  }

  :-ms-input-placeholder {
    /* Internet Explorer 10-11 */
    color: ${({ theme }) => theme.colors.grey.neutral};
  }

  ::-ms-input-placeholder {
    /* Microsoft Edge */
    color: ${({ theme }) => theme.colors.grey.neutral};
  }

  /* Toastify */

  :root {
  --toastify-color-light: ${({ theme }) => theme.colors.grey.lightest};
  --toastify-color-dark:  ${({ theme }) => theme.colors.grey.lightest};
  --toastify-color-info: ${({ theme }) => theme.colors.info.lightest};
  --toastify-color-success: ${({ theme }) => theme.colors.success.lightest};
  --toastify-color-warning: ${({ theme }) => theme.colors.warning.lightest};
  --toastify-color-error: ${({ theme }) => theme.colors.error.lightest};

  --toastify-font-family: ${({ theme }) => theme.fontFamily.milliard};

  --toastify-border--success: ${({ theme }) => theme.colors.success.light} 5px solid;
  --toastify-border--error: ${({ theme }) => theme.colors.error.light};
  --toastify-border--info: ${({ theme }) => theme.colors.info.light};
  --toastify-border--warning: ${({ theme }) => theme.colors.warning.light};

  .Toastify__toast-icon {
    align-self: flex-start;

    margin-right: ${({ theme }) => theme.spacing.xxs};
    svg {
      width: 16px;
      height: 16px;
    }
  }

  Toastify__toast-icon--success {
    color: ${({ theme }) => theme.colors.success.dark};
    margin-right: ${({ theme }) => theme.spacing.xxs};
  }
  Toastify__toast-icon--error {
    color: ${({ theme }) => theme.colors.error.dark};
    margin-right: ${({ theme }) => theme.spacing.xxs};
  }
  Toastify__toast-icon--info {
    color: ${({ theme }) => theme.colors.info.neutral};
    margin-right: ${({ theme }) => theme.spacing.xxs};
  }
  Toastify__toast-icon--warning {
    color: ${({ theme }) => theme.colors.warning.dark};
    margin-right: ${({ theme }) => theme.spacing.xxs};
  }

  .Toastify__toast--success {
  border-radius: ${({ theme }) => theme.borderRadius.rounded};
    border: 1px solid ${({ theme }) => theme.colors.success.lighter};
  }

  .Toastify__toast--error {
    border-radius: ${({ theme }) => theme.borderRadius.rounded};
    border: 1px solid ${({ theme }) => theme.colors.error.lighter};
  }

  .Toastify__toast--info {
    border-radius: ${({ theme }) => theme.borderRadius.rounded};
    border: 1px solid ${({ theme }) => theme.colors.info.lighter};
  }

  .Toastify__toast--warning {
    border-radius: ${({ theme }) => theme.borderRadius.rounded};
    border: 1px solid ${({ theme }) => theme.colors.warning.lighter};
  }

  --toastify-text-color-light: ${({ theme }) => theme.colors.grey.neutral};
  --toastify-text-color-dark: ${({ theme }) => theme.colors.grey.neutral};
  --toastify-text-color-info: ${({ theme }) => theme.colors.info.neutral};
  --toastify-text-color-success: ${({ theme }) => theme.colors.success.neutral};
  --toastify-text-color-warning: ${({ theme }) => theme.colors.warning.neutral};
  --toastify-text-color-error: ${({ theme }) => theme.colors.error.neutral};

  --toastify-color-progress-info: var(--toastify-text-color-info);
  --toastify-color-progress-success: var(--toastify-text-color-success);
  --toastify-color-progress-warning: var(--toastify-text-color-warning);
  --toastify-color-progress-error: var(--toastify-text-color-error);
}
/*
* Toast Container width: As we will be having different Toast width,
* keeping this Toastify width as Auto so that we can set our own width
*/

.Toastify__close-button {
  align-self: start;
  position: relative;
  top:10px;
  float: right;
  svg{
    color: ${({ theme }) => theme.colors.grey.dark};
    ${({ theme }) => theme.typography.s.medium};
  }
  margin-left: ${({ theme }) => theme.spacing.xxxl};
}

.Toastify__toast-container {
  width: auto;
  border-radius: ${({ theme }) => theme.borderRadius.rounded};
}

/*
* Toast style changed as oer the design
* below are the override custom css
*/

.Toastify__toast {
  transform: translateX(0px);
  opacity: 1;
  max-width: 35rem;
  ${({ theme }) => theme.typography.s.medium};
  padding: ${({ theme }) => theme.spacing.xs} ${({ theme }) => theme.spacing.s};
  transition: transform 0.2s ease 0s, opacity 0.2s ease 0s;
  border-radius: ${({ theme }) => theme.borderRadius.normal};
}





.Toastify__progress-bar-theme--colored.Toastify__progress-bar--info {
  background: ${({ theme }) => theme.colors.info.lightest}!important;
}
.Toastify__progress-bar-theme--colored.Toastify__progress-bar--success {
  background: ${({ theme }) => theme.colors.success.lightest}!important;
}
.Toastify__progress-bar-theme--colored.Toastify__progress-bar--warning {
  background: ${({ theme }) => theme.colors.warning.lightest}!important;
}
.Toastify__progress-bar-theme--colored.Toastify__progress-bar--error {
  background: ${({ theme }) => theme.colors.error.lightest}!important;

.Toastify__progress-bar--animated {
  right: 0;
  left: initial;
  transform-origin: right;
}


// Dropdown
.dropdown {
  .dropdown-item {
    svg {
      position: relative;
      top: -0.125rem;
    }
  }
}
`
